// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

// shared components
import CustomSwitch from '@/components/ui/switch/CustomSwitch';

// relative
import type { DataViewerSettings } from '../hooks/useDataViewerSettings';

interface DataViewerSettingsDialogProps {
  open: boolean;
  onClose: () => void;
  settings: DataViewerSettings;
  onChange: (patch: Partial<DataViewerSettings>) => void;
}

const DataViewerSettingsDialog = ({
  open,
  onClose,
  settings,
  onChange,
}: DataViewerSettingsDialogProps) => {
  const { t } = useTranslation('view-data');

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('settings.title')}</DialogTitle>
      <DialogContent>
        <List disablePadding>
          <ListItem
            disableGutters
            secondaryAction={
              <CustomSwitch
                edge="end"
                checked={settings.yAxisStartsAtZero}
                onChange={(e) =>
                  onChange({ yAxisStartsAtZero: e.target.checked })
                }
                slotProps={{
                  input: { 'aria-labelledby': 'y-axis-starts-at-zero-label' },
                }}
              />
            }
          >
            <ListItemText
              id="y-axis-starts-at-zero-label"
              primary={t('settings.y_axis_starts_at_zero')}
              secondary={t('settings.y_axis_starts_at_zero_description')}
            />
          </ListItem>
          <Divider />
          <ListItem
            disableGutters
            secondaryAction={
              <CustomSwitch
                edge="end"
                checked={settings.showAllSeriesByDefault}
                onChange={(e) =>
                  onChange({ showAllSeriesByDefault: e.target.checked })
                }
                slotProps={{
                  input: { 'aria-labelledby': 'show-all-series-label' },
                }}
              />
            }
          >
            <ListItemText
              id="show-all-series-label"
              primary={t('settings.show_all_series_by_default')}
              secondary={t('settings.show_all_series_by_default_description')}
            />
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('settings.close')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DataViewerSettingsDialog;
